import React from 'react';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';

const FormField = ({ label, id, type = 'text', required = false, value, onChange, placeholder, className = 'w-full' }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">
      {label} {required && '*'}
    </label>
    <Input
      id={id}
      name={id}
      type={type}
      required={required}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      className={className}
    />
  </div>
);

const FormTextarea = ({ label, id, required = false, value, onChange, placeholder, rows = 5, className = 'w-full resize-none' }) => (
  <div>
    <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-2">
      {label} {required && '*'}
    </label>
    <Textarea
      id={id}
      name={id}
      required={required}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      className={className}
    />
  </div>
);

export { FormField, FormTextarea };
